/* Modules */
import { BrowserModule, Title } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AuthResetFormModule } from "./pages/password-reset-form/auth-reset-form.module";
import { SharedUtilityModule } from "./shared-utility/shared-utility.module";
import { RegistrationFormModule } from "./pages/registration-form/registration-form.module";
import { PrimeNgComponentsModule } from "./prime-ng-components/prime-ng-components.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthHeaderInterceptor } from "./shared-utility/services/auth-header.interceptor";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { ToastrModule } from "ngx-toastr";
import { HttpClientModule } from "@angular/common/http";
// import { MatdialogModule } from "@angular/material/dialog";
/* Components */
import { AppComponent } from "./app.component";
import { LoginComponent } from "./pages/login/login.component";
import { HeaderComponent } from "./components/header/header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { LoaderComponent } from "./components/loader/loader.component";

/* Service */
import { SharedFormService } from "./shared-utility/services/shared-form.service";
import { SharedStateService } from "./shared-utility/services/shared-state.service";
import { PhoneMaskDirective } from "./shared-utility/common/phone-mask-directive";
import { NgbDateParserFormatter, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { SecurityQuestionsComponent } from './pages/security-questions/security-questions.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { GoogleAnalyticsService } from "./google-analytics.service";
import { PopupModule } from "./components/common/popup/popup.module";
import { RedirectDocusignComponent } from './redirect-docusign/redirect-docusign.component';
import { UnderConstructionComponent } from './pages/under-construction/under-construction.component';
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { PatientEsignatureAuthorizationComponent } from './pages/patient-esignature-authorization/patient-esignature-authorization.component';
import { SafePipe } from "./pages/patient-esignature-authorization/safe-pipe";
import { environment } from 'src/environments/environment';
import { RedirectPatientEsignatureComponent } from './pages/redirect-patient-esignature/redirect-patient-esignature.component';
import { SplashPageComponent } from './splash-page/splash-page.component';
import { NgbDateCustomParserFormatterService } from "./pages/dashboard/ngb-date-custom-parser-formatter.service";


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HeaderComponent,
    FooterComponent,
    LoaderComponent,
    PhoneMaskDirective,
    SecurityQuestionsComponent,
    RedirectDocusignComponent,
    UnderConstructionComponent,
    ResetPasswordComponent,
    PatientEsignatureAuthorizationComponent,
    SafePipe,
    RedirectPatientEsignatureComponent,
    SplashPageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    AuthResetFormModule,
    SharedUtilityModule,
    RegistrationFormModule,
    PrimeNgComponentsModule,
    BrowserAnimationsModule,
    PdfViewerModule,
    ToastrModule.forRoot({ closeButton: true }),
    NgbModule,
    NgSelectModule,
    HttpClientModule,
  ],
  providers: [
    Title,
    GoogleAnalyticsService,
    SharedFormService,
    SharedStateService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthHeaderInterceptor,
      multi: true,
    },
    {
      provide: NgbDateParserFormatter,
      useClass: NgbDateCustomParserFormatterService,
    },
    {
    provide: 'WEBCHAT_URL', useValue: {
        webChatUrl: environment.webChatUrl
    },
   },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
